import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return [
      "monthlyPrice",
      "yearlyPrice",
      "btnUpgrade",
      "monthlyBtn",
      "yearlyBtn",
      "changeToYearlyBtn",
      "disabledCurrentBtn",
    ]
  }

  togglePrice(e) {
    if (e.target.dataset.billingCycle == "yearly") {
      this._hide(this.monthlyPriceTargets)
      this._hide(this.disabledCurrentBtnTargets)
      this._show(this.yearlyPriceTargets)
      this._show(this.changeToYearlyBtnTargets)

      this._updateLinkHref(this.btnUpgradeTargets, "monthly", "yearly")
      this.yearlyBtnTarget.classList.add("is-active")
      this.monthlyBtnTarget.classList.remove("is-active")
    } else {
      this._hide(this.yearlyPriceTargets)
      this._hide(this.changeToYearlyBtnTargets)
      this._show(this.monthlyPriceTargets)
      this._show(this.disabledCurrentBtnTargets)

      this._updateLinkHref(this.btnUpgradeTargets, "yearly", "monthly")
      this.monthlyBtnTarget.classList.add("is-active")
      this.yearlyBtnTarget.classList.remove("is-active")
    }
  }

  displayPlan(e) {
    Array.from(document.getElementsByClassName("pricing-table__plan-column")).forEach((element) => {
      if (element.dataset.planLevel !== e.target.value) {
        element.classList.add("hidden-xs", "hidden-sm")
      } else {
        element.classList.remove("hidden-xs", "hidden-sm")
      }
    })
  }

  _hide(targets) {
    targets.forEach((element) => {
      element.classList.add("d-none")
    })
  }

  _show(targets) {
    targets.forEach((element) => {
      element.classList.remove("d-none")
    })
  }

  _updateLinkHref(targets, prevBillingCycle, newBillingCycle) {
    targets.forEach((element) => {
      if (element.href) {
        element.href = element.href.replace(prevBillingCycle, newBillingCycle)
      }
    })
  }
}
